import { useQuery } from "@tanstack/react-query";
import { getMe } from "@/adapters/api";
import { useAuth } from "@/store/use-auth";

export function useMe() {
	const session = useAuth((state) => state.session);

	return useQuery({
		queryKey: ["me"],
		queryFn: () => getMe(),
		enabled: !!session,
		staleTime: 60_000,
		retry: false,
	});
}
